import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SpeechOnIcon from '@meronex/icons/ti/TiVolumeUp';
import SpeechOffIcon from '@meronex/icons/ti/TiVolumeMute';
import SpeechIcon from '@meronex/icons/ti/TiVolume';
import Spinner from '@meronex/icons/fi/FiRefreshCw';
import Error from '@meronex/icons/ios/IosAlert';
import bowser from 'bowser';
import { Howl, Howler } from 'howler';

export default class TextToSpeech extends Component {
  state = {
    playing: false,
    speech: undefined,
    loading: false,
    error: false,
  };
  static propTypes = {
    style: PropTypes.object,
    children: PropTypes.node,
    className: PropTypes.string,
    iconSize: PropTypes.number,
    autoPlay: PropTypes.bool,
    play: PropTypes.bool,
    stopOnToggle: PropTypes.bool,
    languageCode: PropTypes.string,
    voiceName: PropTypes.string,
    visible: PropTypes.bool,
    text: PropTypes.string,
  };
  static defaultProps = {
    load: true,
    play: null,
    stopOnToggle: false,
    autoPlay: false,
    iconSize: 12,
    languageCode: 'en-GB',
    voiceName: 'en-GB-Wavenet-A',
    visible: true,
  };

  componentDidMount() {
    const { autoPlay, children, load } = this.props;
    this.mounted = true;
    if (load) {
      this.load(() => {
        if (autoPlay) {
          this.play();
        }
      });
    }
  }

  componentWillReceiveProps(next) {
    if (next.load && !this.state.speech) {
      this.load();
    }
    if (next.text !== this.props.text && this.state.speech) {
      this.stop();
      this.setState(
        {
          speech: undefined,
          playing: false,
        },
        () => {
          this.load();
        }
      );
    }
    if (!this.state.playing && next.play) {
      this.play();
    }
    if (this.state.playing && !next.play) {
      this.stop();
    }
  }

  componentWillUnmount() {
    console.log('unmouning ');
    this.mounted = false;
    if (this.state.speech) {
      this.state.speech.stop();
    }
    this.setState({
      playing: false,
    });
  }

  fetchText2Speech = async ({ text, encoding }) => {
    const { languageCode, voiceName } = this.props;
    const data = {
      input: {
        text,
      },
      //https://cloud.google.com/text-to-speech/docs/voices
      voice: {
        languageCode,
        name: voiceName,
      },
      audioConfig: {
        audioEncoding: encoding.toLowerCase() === 'mp3' ? 'MP3' : 'OGG_OPUS',
        speakingRate: 0.8,
      },
    };
    const response = await fetch(
      'https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyCaPrG87PS5HeffH7h7jyKXGR58TpQ0D5w',
      {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        headers: {
          'Content-Type': 'application/json',
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse.audioContent; // parses JSON response into native JavaScript objects
  };
  text2Speech = async (text) => {
    const { autoPlay } = this.props;
    const encoding =
      bowser.name.toLocaleLowerCase() === 'chrome' ? 'opus' : 'mp3';
    try {
      const audioContent = await this.fetchText2Speech({
        text,
        encoding,
      });
      if (this.mounted) {
        const speech = new Howl({
          src: [`data:audio/wav;base64, ${audioContent}`],
          html5: true,
          onend: () => {
            console.log('Finished!');
            if (this.mounted) {
              this.setState({
                playing: false,
              });
            }
          },
        });
        speech.autoplay = false;
        this.setState(
          {
            speech,
            loading: false,
          },
          () => {
            setTimeout(() => {
              if (autoPlay) {
                console.log('playing..');

                this.play();
              }
            }, 500);
          }
        );
      }
    } catch (e) {
      console.log(e);
      this.setState({
        loading: false,
        error: true,
        speech: undefined,
      });
    }
  };

  sanitize = (html) => {
    const cleanedUp = html
      .replace(/<\/p>/g, '. </p>')
      .replace(/<\/li>/g, '. </li>')
      .replace(/<\/br>/g, '. </br>');
    const tmp = document.createElement('DIV');
    tmp.innerHTML = cleanedUp;
    return tmp.textContent || tmp.innerText || '';
  };

  load(cb) {
    const { children, text } = this.props;
    const textToProcess = text || children;
    if (this.mounted && !this.state.loading) {
      this.setState(
        {
          loading: true,
        },
        () => {
          if ((text || children) && !this.state.speech) {
            this.text2Speech(textToProcess);
          }
        }
      );
    }
  }
  play() {
    const speech = this.state.speech;
    if (speech) {
      speech.play();
      this.setState({
        playing: true,
      });
    } else {
      this.load(() => {
        this.play();
      });
    }
  }
  pause() {
    const speech = this.state.speech;
    if (speech && this.state.playing) {
      speech.pause();
      this.setState({
        playing: false,
      });
    }
  }

  stop() {
    const speech = this.state.speech;
    if (speech && this.state.playing) {
      speech.stop();
      this.setState({
        playing: false,
      });
    }
  }

  togglePlay() {
    const { stopOnToggle } = this.props;
    const { playing } = this.state;
    if (playing) {
      stopOnToggle ? this.stop() : this.pause();
    } else {
      this.play();
    }
  }
  render() {
    const { visible } = this.props;
    const { error, loading, speech, playing } = this.state;
    const containerStyle = {
      width: '35px',
      borderRadius: '100%',
      height: '35px',
      textAlign: 'center',
      paddingTop: '3px',
    };

    return (
      <div
        className={this.props.className}
        onClick={() => {
          // If play prop is defined, then respect its
          // value since this will be a controlled component

          this.togglePlay();
        }}
        style={Object.assign(containerStyle, this.props.style)}>
        {loading && <Spinner className={'icon-spin'} />}
        {error && <Error />}
        {speech && (
          <div style={{ cursor: 'pointer' }}>
            {playing && <SpeechOffIcon size={this.props.iconSize} />}
            {!playing && <SpeechOnIcon size={this.props.iconSize} />}
          </div>
        )}
        {!speech && !loading && <SpeechIcon size={this.props.iconSize} />}
      </div>
    );
  }
}
